<template>
  <div>
    <a-form
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :style="{ top: 0 }"
    >
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="THÔNG TIN CHUNG">
          <a-form-item label="Điểm nhận hàng" name="location_destination">
            <o-select
              v-model:value="form.location_destination"
              @input="form.location_destination = $event"
              placeholder="Vui lòng chọn điểm nhận hàng"
              entity="location"
              :title="'Điểm nhận hàng'"
            />
          </a-form-item>
          <a-form-item label="Ngày nhận hàng" name="ETD_date">
            <a-date-picker
              v-model:value="form.ETD_date"
              :locale="locale"
              type="date"
              format="DD-MM-YYYY"
              :style="{ width: '50%' }"
            />
            <a-time-picker
              v-model:value="form.ETD_time"
              :locale="locale"
              format="HH:mm"
              placeholder="Chọn giờ"
              :style="{ width: '50%', paddingLeft: '10px' }"
            />
          </a-form-item>
          <a-form-item label="Điểm trả hàng" name="location_arrival">
            <o-select
              v-model:value="form.location_arrival"
              @input="form.location_arrival = $event"
              placeholder="Vui lòng chọn điểm trả hàng"
              entity="location"
              :title="'Điểm trả hàng'"
              :isDisplay="'none'"
              :isDisplayAdd="'none'"
            />
          </a-form-item>
          <a-form-item label="Ngày trả hàng" name="ETA_date">
            <a-date-picker
              v-model:value="form.ETA_date"
              :locale="locale"
              type="date"
              format="DD-MM-YYYY"
              :style="{ width: '50%' }"
            />
            <a-time-picker
              v-model:value="form.ETA_time"
              :locale="locale"
              format="HH:mm"
              placeholder="Chọn giờ"
              :style="{ width: '50%', paddingLeft: '10px' }"
            />
          </a-form-item>
          <a-form-item label="Hàng hóa" class="goods-type-header">
            <div class="goods-type-inputs goods-type-column-titles">
              <!-- <span>Thể tích (m³)</span> -->
              <span>Khối lượng (lít)</span>
            </div>
          </a-form-item>
          <a-form-item
            v-for="item in goodsTypePreview"
            :key="item.goods_type_id"
            :label="item.title"
            class="goods-type-item"
          >
            <div class="goods-type-inputs">
              <!-- <a-input-number
                v-model:value="item.volume"
                :min="0"
                :step="1"
                :precision="0"
                :parser="parseInteger"
                placeholder="Nhập thể tích"
              /> -->
              <a-input-number
                v-model:value="item.weight"
                :min="0"
                :step="1"
                :precision="0"
                :parser="parseInteger"
                placeholder="Nhập khối lượng"
              />
            </div>
          </a-form-item>
          <a-form-item v-if="goodsTypeLoading" label=" ">
            <a-spin size="small" />
          </a-form-item>
          <!-- <a-form-item label="Yêu cầu xe" name="listVehicleGroup">
            <div class="form-border">
              <a-list :data-source="relationForm.listVehicleGroup">
                <template #header>
                  <a-row :gutter="16">
                    <a-col class="gutter-row" :span="16">
                      <h2 class="header-list">Chủng loại xe</h2>
                    </a-col>
                    <a-col class="gutter-row" :span="4">
                      <h2 class="header-list">Số lượng</h2>
                    </a-col>
                  </a-row>
                </template>
                <template #renderItem="{ item }" :style="{ marginTop: '10px' }">
                  <a-row :gutter="16" style="padding: 4px 0">
                    <a-col class="gutter-row" :span="16">
                      <span class="name-vehicle">
                        <QuestionCircleOutlined
                          :style="{ color: 'rgb(24, 144, 255)' }"
                        />
                        {{ item.name_of_vehicle_group_id }}
                      </span>
                    </a-col>
                    <a-col class="gutter-row" :span="4">
                      <a-input-number
                        :style="{ width: '100px' }"
                        v-model:value="item.vehicle_number"
                        :min="0"
                      />
                    </a-col>
                  </a-row>
                </template>
              </a-list>
            </div>
          </a-form-item> -->

          <a-form-item style="display: none">
            <a-input v-model:value="form.way_type" />
          </a-form-item>
          <a-form-item style="display: none">
            <a-input v-model:value="form.amount_transport" />
          </a-form-item>
          <a-form-item style="display: none">
            <a-input v-model:value="form.amount_option" />
          </a-form-item>
          <a-form-item style="display: none">
            <a-input v-model:value="form.amount_loading" />
          </a-form-item>
        </a-tab-pane>
        <a-tab-pane key="2" tab="THÔNG TIN ĐÍNH KÈM">
          <a-form-item label="Đính kèm">
            <div class="clearfix">
              <a-upload
                list-type="picture-card"
                :multiple="true"
                :customRequest="customRequest"
                :before-upload="beforeUpload"
                @change="handleChange"
                @preview="handlePreview"
                v-model:file-list="relationForm.list_files"
              >
                <div>
                  <plus-outlined />
                  <div class="ant-upload-text">Thêm tệp đính kèm ở đây</div>
                </div>
              </a-upload>
              <a-modal
                :visible="previewVisible"
                :footer="null"
                @cancel="handleCancelPreview"
              >
                <img alt="picture" style="width: 100%" :src="previewImage" />
              </a-modal>
            </div>
          </a-form-item>
        </a-tab-pane>
      </a-tabs>
    </a-form>
  </div>
</template>

<script>
import VehicleGroupService from "@/services/VehicleGroupService";
import FileService from "@/services/FileService";
import OneLogSelect from "@/components/Select/OneLogSelect";
import axios from "axios";
import locale from "ant-design-vue/es/date-picker/locale/vi_VN";
import formUtility from "@/formUtility";
import mixins from "@/mixins";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";

const DEFAULT_DESTINATION_KEYWORD = "Đức Giang";
const DEFAULT_DESTINATION_TITLE = "Tổng kho Đức Giang";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default {
  mixins: [formUtility, mixins],
  components: {
    "o-select": OneLogSelect,
    QuestionCircleOutlined,
  },
  props: {
    formData: {},
    show: {
      type: Boolean,
      default: false,
    },
    spinLoading: {
      type: Boolean,
      default: true,
    },
    prefetchedLocations: {
      type: Array,
      default: () => [],
    },
    prefetchedGoodsTypes: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.getVehicleGroupList();
    this.loadGoodsTypePreview();
    this.relationForm.list_files = this.formData
      ? this.formData.list_files
      : this.form.list_files || [];

    this.formData.status = -2;
    this.formData.is_auto_gen_orders = 1;
    this.setDefaultDestination();
  },
  watch: {
    show(val) {
      if (val) {
        this.getVehicleGroupList();
        this.loadGoodsTypePreview();
        this.relationForm.list_files = [];
        this.setDefaultDestination();
      } else {
        this.relationForm.list_files = this.formData
          ? this.formData.list_files
          : this.form.list_files || [];
      }
    },
    prefetchedGoodsTypes(items) {
      if (items && items.length) {
        this.setGoodsTypePreview(items);
      }
    },
    prefetchedLocations(items) {
      if (items && items.length) {
        this.setDefaultDestination();
      }
    },
  },
  data() {
    let validateLocation = (rule, value) => {
      if (typeof value === "undefined" || value == "") {
        return Promise.reject("Vui lòng nhập địa điểm");
      } else {
        return Promise.resolve();
      }
    };
    let fields = [
      {
        name: "location_destination",
        validator: validateLocation,
        trigger: ["change", "blur"],
      },
      {
        name: "location_arrival",
        validator: validateLocation,
        trigger: ["change", "blur"],
      },
    ];
    let rules = this.generateRules("Order", fields);
    return {
      rules,
      locale,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      fileID: [],
      defaultDestinationLoading: false,
      goodsTypeLoading: false,
      goodsTypePreview: [],

      relationForm: {
        listVehicleGroup: this.formData.listVehicleGroup || [],
        list_files: this.formData.list_files || [],
      },
      activeTab: 1,
      form: this.formData,
    };
  },

  methods: {
    parseInteger(value) {
      const match = String(value).match(/^\d+/);
      return match ? match[0] : "";
    },

    setGoodsTypePreview(items) {
      this.goodsTypePreview = items.map((item) => ({
        goods_type_id: item.id,
        code: item.code,
        title: item.title,
        volume: null,
        weight: null,
      }));
    },

    loadGoodsTypePreview() {
      if (this.prefetchedGoodsTypes.length) {
        this.setGoodsTypePreview(this.prefetchedGoodsTypes);
        return;
      }

      this.getGoodsTypeList();
    },

    getGoodsTypeList() {
      if (this.goodsTypeLoading) {
        return;
      }

      this.goodsTypeLoading = true;
      axios
        .post("c-goods/list", {
          pageSize: 100,
          pageIndex: 1,
          textSearch: "",
          ids: [],
          sort: [],
        })
        .then((response) => {
          const responseData = response.data && response.data.data;
          const items = responseData && responseData.items
            ? responseData.items
            : [];
          this.setGoodsTypePreview(items);
        })
        .catch((error) => {
          console.error("Không thể tải danh sách hàng hóa", error);
        })
        .finally(() => {
          this.goodsTypeLoading = false;
        });
    },

    setDefaultDestination() {
      if (
        this.form.mode !== "add" ||
        this.form.location_destination ||
        this.defaultDestinationLoading
      ) {
        return;
      }

      const prefetchedDestination =
        this.prefetchedLocations.find(
          (item) => item.title === DEFAULT_DESTINATION_TITLE
        ) || this.prefetchedLocations[0];

      if (prefetchedDestination) {
        this.form.location_destination = {
          key: prefetchedDestination.id,
          value: prefetchedDestination.title,
          label: prefetchedDestination.title,
        };
        return;
      }

      this.defaultDestinationLoading = true;
      axios
        .post("c-location/list", {
          pageSize: 20,
          pageIndex: 1,
          textSearch: "",
          filters: [
            {
              field: "title",
              operator: "like",
              value: DEFAULT_DESTINATION_KEYWORD,
            },
          ],
          ids: [],
          sort: [],
        })
        .then((response) => {
          const responseData = response.data && response.data.data;
          const items = responseData && responseData.items
            ? responseData.items
            : [];
          const destination =
            items.find((item) => item.title === DEFAULT_DESTINATION_TITLE) ||
            items[0];

          if (
            destination &&
            this.form.mode === "add" &&
            !this.form.location_destination
          ) {
            this.form.location_destination = {
              key: destination.id,
              value: destination.title,
              label: destination.title,
            };
          }
        })
        .catch((error) => {
          console.error("Không thể tải điểm nhận hàng mặc định", error);
        })
        .finally(() => {
          this.defaultDestinationLoading = false;
        });
    },

    getVehicleGroupList() {
      if (this.form.mode === "add") {
        VehicleGroupService.all()
          .then((response) => {
            if (response.data.errorCode == 0) {
              this.relationForm.listVehicleGroup = [];
              response.data.data.results.map((p) => {
                this.relationForm.listVehicleGroup.push({
                  vehicle_group_id: p.vehicle_group_id,
                  name_of_vehicle_group_id: p.name_of_vehicle_group_id,
                  vehicle_number: 0,
                });
              });
            }
          })
          .catch((error) => {
            this.$message.error(error.message);
          });
      }
    },

    handleChange(info) {
      const status = info.file.status;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleCancelPreview() {
      this.previewVisible = false;
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("Bạn chỉ được upload ảnh định dạng jpeg hoặc png");
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("Dung lượng ảnh không được quá 5MB");
      }
      return isJpgOrPng && isLt5M;
    },
    customRequest(options) {
      const { onSuccess, onError, file } = options;
      FileService.upload(file)
        .then((respones) => {
          onSuccess(respones.data.data.fileId);
        })
        .catch((err) => {
          onError(err);
        });
    },
  },
};
</script>

<style scoped>
.ant-form-item {
  margin-bottom: 16px;
}

.validate-form {
  margin-top: -14px;
  color: red;
  transition: all 0.5s ease 0s;
}

.header {
  display: flex;
  height: 50px;
  border-bottom: 1px solid #e8e8e8;
}

.header-title {
  margin-right: 8px;
  display: flex;
  align-items: center;
  font-weight: 600;
  padding: 0 4px;
}

.header-title-goods {
  width: 200px;
}

.header-title-unit {
  width: 100px;
}

.header-title-quantity {
  width: 80px;
}

.header-title-weight {
  width: 100px;
}

.header-title-volumn {
  width: 100px;
}

.header-title-insured {
  width: 50px;
}

.header-title.header-title-space {
  width: 60px;
  margin-right: 0;
}

.anticon.anticon-delete {
  margin-left: 8px;
  cursor: pointer;
  color: red;
}

.ant-btn {
  padding: 0 8px;
}

.ant-row.form-item:before {
  display: table;
  content: "*";
  position: absolute;
  top: 11px;
  color: red;
  left: 59px;
}
.header-list {
  font-size: 14px;
  margin: 0;
}
.form-border {
  border: 1px solid #d9d9d9;
  padding: 0 10px;
  border-radius: 4px;
}
.ant-list-split .ant-list-header {
  border-bottom: 1px solid #f0f0f0 !important;
}
.goods-type-inputs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  align-items: center;
}
.goods-type-inputs :deep(.ant-input-number) {
  width: 100%;
}
.goods-type-header,
.goods-type-item {
  margin-bottom: 8px;
}
.goods-type-column-titles {
  color: #666;
  font-size: 12px;
}
</style>
